const routesmap = [
  // Calling Card
  {
    path: "pinmanagement/cabin",
    module: "callingcard",
    action: "management.cabin",
  },
  {
    path: "pinmanagement/admin",
    module: "callingcard",
    action: "management.admin",
  },
  {
    path: "pincdr/cabin",
    module: "callingcard",
    action: "cdr.cabin",
  },
  {
    path: "pincdr/admin",
    module: "callingcard",
    action: "cdr.admin",
  },
  {
    path: "callingrate",
    module: "callingcard",
    action: "rates",
  },
  {
    path: "reportschedule",
    module: "utils",
    action: "reportschedule",
  },

  // PBX

  {
    path: "registration",
    module: "pbx",
    action: "registration",
  },
  {
    path: "extension",
    module: "pbx",
    action: "extension",
  },
  {
    path: "ringgroup",
    module: "pbx",
    action: "ringgroup",
  },
  {
    path: "inboundroute",
    module: "pbx",
    action: "inboundroute",
  },
  {
    path: "voicemail",
    module: "pbx",
    action: "voicemail",
  },
  {
    path: "hardware",
    module: "pbx",
    action: "hardware",
  },

  // user

  {
    path: "user",
    module: "user",
    action: "management",
  },
  {
    path: "userdetails",
    module: "user",
    action: "management",
  },
];

export default routesmap;
